import { createFileRoute } from '@tanstack/react-router';

import { useMobileDevice } from '../hooks/useMedia';
import { InternalDocuments } from '../modules/ComponentsLibrary/InternalDocuments';
import { InternalDocumentsMobile } from '../modules/ComponentsLibrary/InternalDocuments/InternalDocumentsMobile';
import { internalResourceSearchScheme } from '../modules/ComponentsLibrary/InternalDocuments/InternalDocumentsSearchForm.hooks';

export const Route = createFileRoute('/documents')({
  component: RouteComponent,
  validateSearch: internalResourceSearchScheme,
  head(ctx) {
    return {
      meta: [{ title: 'Internal Resources' }],
    };
  },
});

function RouteComponent() {
  const isMobileDevice = useMobileDevice();
  return isMobileDevice ? <InternalDocumentsMobile /> : <InternalDocuments />;
}
